
import React, { useState } from "react";
import Fade from "react-reveal/Fade";
import IconImg from "../../assets/images/icons/quote-up.svg";
import { BsFillStarFill } from "react-icons/bs";
import { IoChevronBackOutline, IoChevronForwardOutline } from "react-icons/io5";
import { FaQuoteLeft } from "react-icons/fa";

function Testimonial() {
  const [current, setCurrent] = useState(0);
  const visibleCount = window.innerWidth <= 576 ? 1 : 2;
  const maxIndex = Data.length - visibleCount;

  const prev = () => setCurrent((c) => Math.max(0, c - 1));
  const next = () => setCurrent((c) => Math.min(maxIndex, c + 1));
  return (
    <div className="testimonial-section py-5">
      <div className="container">
        <Fade bottom>
          <h3 className="title-home-page-theme text-center mb-5">
            Ce que nos clients pensent de nous
          </h3>
        </Fade>
        <div className="testimonial-carousel-outer">
          <button
            className="testi-arrow testi-arrow-left"
            onClick={prev}
            disabled={current === 0}
            aria-label="Précédent"
          >
            <IoChevronBackOutline size={20} />
          </button>

          <div className="testimonial-carousel-viewport">
            <div
              className="testimonial-carousel-track"
              style={{ transform: `translateX(calc(-${current} * (50% + 10px)))` }}
            >
              {Data.map((testimonial) => (
                <TestimonialItem item={testimonial} key={testimonial.id} />
              ))}
            </div>
          </div>

          <button
            className="testi-arrow testi-arrow-right"
            onClick={next}
            disabled={current === maxIndex}
            aria-label="Suivant"
          >
            <IoChevronForwardOutline size={20} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Testimonial;



export const TestimonialItem = ({ item }: { item: any }) => {
  return (
    <div className="container-testimonial-item">
      <div className="content-img-icon-testimonial">
        <FaQuoteLeft className="img-icons" size={24} />
      </div>
      <div className="container-text-testimonial py-3">
        <p className="text-item-testimonial">{item.text}</p>
      </div>
      <div className="content-footer-testimonial w-100">
        <p className="m-0 name-user-testimonial">{item.name}</p>
        <div className="content-item-footer-testimonial">
          {Array(item.rate).fill(0).map((_, i) => (
            <span className="icon-rate-user-testimonial" key={i}>
              <BsFillStarFill size={14} color="#5FC500" />
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
const Data = [
  {
    id: 1,
    text: "Service professionnel, livraison rapide et excellente qualité des produits.",
    icon: IconImg,
    name: "Client satisfait",
    rate: 5,
  },
  {
    id: 2,
    text: "Très bonne expérience, équipe sérieuse et à l'écoute",
    icon: IconImg,
    name: "Client satisfait",
    rate: 5,
  },
  
    {
    id: 3,
    text: "Je recommande LE CORAN SOIGNE pour son professionnalisme et son excellent service client.",
    icon: IconImg,
    name: "Client satisfait",
    rate: 5,
  },
    {
    id: 4,
    text: "Je recommande LE CORAN SOIGNE pour son professionnalisme et son excellent service client.",
    icon: IconImg,
    name: "Client satisfait",
    rate: 5,
  },
];




